import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import DeletedAccounts from './pages/DeletedAccounts';
import UserDetails from './pages/UserDetails';
import Reports from './pages/Reports';
import Contacts from './pages/Contacts';
import Analytics from './pages/Analytics';
import RegionalInsights from './pages/RegionalInsights';
import UserActivity from './pages/UserActivity';
import Subscriptions from './pages/Subscriptions';
import Verifications from './pages/Verifications';
import VerifiedUsers from './pages/VerifiedUsers';
import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';
import { ThemeProvider } from './contexts/ThemeContext';
import { NotificationProvider } from './contexts/NotificationContext';
import './App.css';
import PromotionActivity from './pages/PromotionActivity';
import Impressions from './pages/Impressions';
import PushNotifications from './pages/PushNotifications';
import CommunityModeration from './pages/CommunityModeration';
import HiddenUsers from './pages/HiddenUsers';
import AdminManagement from './pages/AdminManagement';
import ModerationTester from './pages/ModerationTester';
import GroupTracker from './pages/GroupTracker';

function App() {
  return (
    <ThemeProvider>
      <NotificationProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Layout />
                </PrivateRoute>
              }
            >
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="users" element={<Users />} />
              <Route path="users/:userId" element={<UserDetails />} />
              <Route path="deleted-accounts" element={<DeletedAccounts />} />
              <Route path="reports" element={<Reports />} />
              <Route path="contacts" element={<Contacts />} />
              <Route path="app-promotions" element={<PromotionActivity />} />
              <Route path="impressions" element={<Impressions />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="regional-insights" element={<RegionalInsights />} />
              <Route path="user-activity" element={<UserActivity />} />
              <Route path="subscriptions" element={<Subscriptions />} />
              <Route path="verifications" element={<Verifications />} />
              <Route path="verified-users" element={<VerifiedUsers />} />
              <Route path="photo-verifications" element={<Navigate to="/community-moderation?tab=profile-pictures" replace />} />
              <Route path="push-notifications" element={<PushNotifications />} />
              <Route path="community-moderation" element={<CommunityModeration />} />
              <Route path="group-tracker" element={<GroupTracker />} />
              <Route path="moderation-tester" element={<ModerationTester />} />
              <Route path="hidden-users" element={<HiddenUsers />} />
              <Route path="admin-management" element={<AdminManagement />} />
            </Route>
          </Routes>
        </Router>
      </NotificationProvider>
    </ThemeProvider>
  );
}

export default App;
